<template>
  <div class="d-flex flex-column flex h100">
    <navbar></navbar>
    <div class="app">
      <config-sidenav></config-sidenav>
      <div id="content" class="app-content box-shadow-3">
        <div id="navbar" class="navbar navbar-expand-lg">
          <!-- Page title -->
          <loading type="header" v-if="assessment.loaded == 0" />
          <div
            v-if="assessment.loaded != 0"
            class="navbar-text nav-title flex"
            id="pageTitle"
          >{{ assessment.name }} {{new Date().toLocaleString().replace(',','')}}</div>
        </div>

        <div class="content-main" style="background-color:white">
          <!-- Page content goes here -->
          <div class="h-100" v-if="assessment.loaded != 0 && template">
            <div class="d-sm-flex b-t h-100">
              <div class="w w-auto-xs light bg b-r">
                <div class="py-3">
                  <div class="nav-active-border left b-primary">
                    <ul class="nav flex-column nav-sm">
                      <li class="nav-item">
                        <a
                          class="nav-link nowrap"
                          :class="{ active: tab == 1, show: tab == 1 }"
                          href="#"
                          data-toggle="tab"
                          data-target="#tab-1"
                        >
                          Assessment Details
                          <i
                            class="valid-hint text fa fa-angle-left"
                            style="margin-right: -1rem;"
                            :class="{ invalid: !valid.group('details') }"
                          ></i>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link nowrap"
                          :class="{ active: tab == 2, show: tab == 2 }"
                          href="#"
                          data-toggle="tab"
                          data-target="#tab-2"
                        >Content Creator</a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link nowrap"
                          :class="{ active: tab == 3, show: tab == 3 }"
                          href="#"
                          data-toggle="tab"
                          data-target="#tab-3"
                        >Rubric Builder</a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link nowrap"
                          :class="{ active: tab == 5, show: tab == 5 }"
                          href="#"
                          data-toggle="tab"
                          data-target="#tab-5"
                          v-if="assessment.template_id"
                        >Resources</a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link nowrap"
                          :class="{ active: tab == 4, show: tab == 4 }"
                          href="#"
                          data-toggle="tab"
                          data-target="#tab-4"
                        >Approve</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <edit-pane :cancel="loadData" :save="saveAssessment" :dirty="dirty" :valid="valid">
                <div class="tab-content">
                  <!-- Item Details -->
                  <div
                    class="tab-pane"
                    :class="{ active: defaultTab, show: defaultTab }"
                    id="tab-1"
                  >
                    <div class="p-4 b-b _600 nav-title">Assessment Details</div>
                    <div role="form" class="col-12 col-lg-8">
                      <div class="row m-0 pt-4">
                        <div class="col-12">
                          <div class="form-group" :class="{ invalid: !valid.field('name') }">
                            <label>Assessment Name</label>
                            <input type="text" class="form-control" v-model="assessment.name" />
                          </div>
                        </div>
                        <div class="col-12 col-sm-10">
                          <div
                            class="form-group"
                            :class="{
															invalid: !(
																valid.field('ref') &&
																valid.field('ref_char') &&
																valid.field('ref_unique')
															)
														}"
                          >
                            <label>Reference ID</label>
                            <input type="text" class="form-control" v-model="assessment.ref_id" />
                            <small
                              class="form-text text-muted"
                            >Reference ID must be unique within this tenant</small>
                          </div>
                        </div>
                        <div class="col-2">
                          <label class>Public:</label>
                          <div class="form-group">
                            <label class="ui-switch ui-switch-md theme-accent">
                              <input type="checkbox" v-model="assessment.public" />
                              <i></i>
                            </label>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label>Standards</label>
                            <config-standard-search v-model="assessment.standards" taggable />
                          </div>
                        </div>
                        <div v-if="this.$route.meta.user.client.essential_skills" class="col-12">
                          <div class="form-group">
                            <label>Essential Skills</label>
                            <config-essential-skill-search
                              v-model="assessment.essential_skills"
                              taggable
                            />
                          </div>
                        </div>
                        <div v-if="this.$route.meta.user.client.assessment_purpose" class="col-12">
                          <div class="form-group">
                            <label>Assessment Purpose</label>
                            <config-assessment-purpose-search
                              v-model="assessment.assessment_purpose"
                              taggable
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label>Content Area</label>
                            <v-select
                              class="v-select-apply"
                              :options="contentAreas"
                              v-model="selectedContentArea"
                              @input="updateContentAreaID"
                              label="name"
                            ></v-select>
                          </div>
                        </div>

                        <div class="col-sm-6 col-12">
                          <div class="form-group">
                            <label>Grades</label>
                            <v-select :options="grades" v-model="sGrades" multiple label="name"></v-select>
                          </div>
                        </div>
                        <div class="col-sm-6 col-12">
                          <div class="form-group">
                            <label>Districts</label>
                            <v-select :options="districts" v-model="sDistrict" label="name"></v-select>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label>Description</label>
                            <RichText
                              :text.sync="assessment.description"
                              :initial="originalDesc"
                              :options="{height: 140}"
                              :refresh="refresh"
                              class="border"
                            ></RichText>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- TestViewer -->
                  <test-viewer
                    id="tab-2"
                    :forPreview="false"
                    v-model="assessment"
                    :assessment="assessment"
                  ></test-viewer>
                  <!-- Rubric Picker -->
                  <rubric-picker
                    id="tab-3"
                    :item="assessment"
                    :dirty="dirty"
                    :defaultTab="tab == 3"
                  ></rubric-picker>
                  <!-- Resources -->
                  <item-edit-temp-resources
                    id="tab-5"
                    :assessment="assessment"
                    :item="assessment.item"
                    :originalResources="originalResources"
                    :dirty="dirty"
                    :valid="valid"
                    :save="saveAssessment"
                  ></item-edit-temp-resources>
                  <!-- Approve -->
                  <div class="tab-pane" id="tab-4">
                    <div class="p-4 b-b _600 nav-title">Approve / Feedback</div>
                    <div role="form" class="col-md-12">
                      <div class="row m-0 pt-4">
                        <div class="col-12">
                          <div class="form-group" :class="{ invalid: !valid.field('name') }">
                            <label>Feedback</label>
                            <div v-for="fdb in assessment.feedback" v-bind:key="fdb.message">
                              <p
                                :class="{ left: fdb.type == 1, right: fdb.type == 2 }"
                                class="small"
                              >{{fdb.date}} - {{fdb.username}}</p>
                              <div
                                :class="{ feedback: fdb.type == 1, response: fdb.type == 2 }"
                              >{{fdb.message}}</div>
                            </div>

                            <textarea
                              type="textarea"
                              class="form-control"
                              v-model="feedback.message"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row m-0 pt-4">
                        <div class="col-12">
                          <div @click="saveAssessment(true)" class="btn btn-info">Send Feedback</div>
                          <div
                            v-if="assessment.status != 'In Progress'"
                            @click="ApproveAssessment()"
                            class="btn btn-success"
                          >Approve</div>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
                <!-- Item Details -->
              </edit-pane>
              <save-optional-modal
                :dirty="dirty"
                :valid="valid"
                :save="saveAssessment"
                :next="saveOptNext"
                :cancel="saveOptCancel"
                objectText="Assessment"
                :objectName="assessment.name"
                actionText="leave the page"
                v-model="saveOptModal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <mzfooter></mzfooter>
  </div>
</template>

<style scoped>
.margin-overlap {
  margin-right: -2.5rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.feedback {
  margin: 10px;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
  margin-bottom: 16px;
  padding: 16px;
  line-height: 1.45;
  margin-right: 200px;

  background-color: rgb(201, 203, 205);
  border-radius: 6px;
  color: rgb(36, 41, 46);
}
.response {
  margin: 10px;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
  margin-bottom: 16px;
  padding: 16px;
  margin-left: 200px;
  line-height: 1.45;
  background-color: rgb(0, 132, 255);
  border-radius: 6px;
  color: white;
}
.right {
  text-align: right;
}
</style>

<script>
import Vue from "vue";
import moment from "moment";

import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";
import AssessmentEditDetails from "@/components/assessment/AssessmentEditDetails";
import AssessmentAssign from "@/components/assessment/AssessmentAssign";
import TestViewer from "@/components/assessment/TestViewer";
import RubricPicker from "@/components/assessment/RubricPicker";

import ConfigStandardSearch from "@/components/ConfigStandardSearch";
import ConfigEssentialSkillSearch from "@/components/ConfigEssentialSkillSearch";

import ItemEditDetails from "@/components/item/ItemEditDetails";
import ItemEditScoring from "@/components/item/ItemEditScoring";
import ItemEditViewer from "@/components/item/ItemEditViewer";
import ItemEditTempResources from "@/components/item/ItemEditTempResources";
import ConfigAssessmentPurposeSearch from "@/components/ConfigAssessmentPurposeSearch";
import TemplateService from "@/services/TemplateService";
import RubricService from "@/services/RubricService";

import AssessmentService from "@/services/AssessmentService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";
import DistrictService from "@/services/DistrictService";

export default {
  name: "AssessmentApprove",

  props: ["user", "params", "query"],

  components: {
    "assessment-edit-details": AssessmentEditDetails,
    "item-edit-details": ItemEditDetails,
    "test-viewer": TestViewer,
    "rubric-picker": RubricPicker,
    "item-edit-temp-resources": ItemEditTempResources,
    "config-essential-skill-search": ConfigEssentialSkillSearch,
    "config-assessment-purpose-search": ConfigAssessmentPurposeSearch,

    ConfigStandardSearch,
    EditPane,
    SaveOptionalModal,
    ConfigSelect,
    ConfigItemSearch,
    RichText,
    draggable
  },

  data() {
    return {
      fs: fs,
      assessment: {
        loaded: 0
      },
      loading: true,
      template: null,
      selectedTemplate: null,
      templates: [],
      tab: 1,
      defaultTab: 1,
      id: "tab_1",
      feedback: { message: "", type: 1 },
      contentAreas: [],
      selectedContentArea: null,
      selectedItem: null,
      originalDesc: "",
      refresh: null,
      approving: false,
      originalResources: [],
      isScored: false,
      grades: [],
      sGrades: null,
      RefIDs: [],
      isUnique: true,
      dirty: false,
      valid: {},
      rubricOldID: null,
      saveOptModal: false,
      sDistrict: { name: "None", id: null },
      districts: [],

      saveOptNext: () => {},
      saveOptCancel: () => {}
    };
  },

  computed: {
    sRefID() {
      return this.assessment.ref_id;
    },
    sGradeIDs() {
      return _.map(this.sGrades, "id");
    }
  },

  created() {
    this.loadData();
    this.initValidation();
    this.LoadTemplates();
    if (this.query.tab) {
      this.tab = this.query.tab;
    }
  },

  watch: {
    "assessment.name"() {
      if (this.autoRef) {
        this.assessment.ref_id = this.generateAutoRef(this.assessment.name);
      }
    },
    "assessment.ref_id"() {
      this.checkAutoRef();
    },
    "assessment.rubric"() {
      this.getNewTraits();
    },
    dirty(newVal) {
      if (approving) {
        this.dirty = false;
      }
    },
    dirty(newVal) {
      this.getNewTraits();
      console.log("dirty now ", this.assessment);
    },
    sRefID(newVal) {
      if (this.RefIDs.includes(newVal)) {
        this.isUnique = false;
      } else {
        this.isUnique = true;
      }
    },
    sDistrict(newVal) {
      console.log("new District ");
      this.assessment.district_id = newVal.id;
    },
    sGradeIDs(newVal) {
      let oldVal = this.assessment.grade_ids;
      if (oldVal == null) {
        oldVal = newVal.slice(0, newVal.length - 1);
      }
      let same = true;
      if (newVal.length == oldVal.length) {
        for (let i = 0; i < newVal.length; i++) {
          if (newVal[i] != oldVal[i]) {
            same = false;
          }
        }
      } else {
        same = false;
      }

      if (!same) {
        this.assessment.grade_ids = newVal;
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.dirty) {
      this.saveOptNext = () => {
        next();
      };
      this.saveOptCancel = () => {
        next(false);
      };
      this.saveOptModal = true;
    } else {
      next();
    }
  },

  methods: {
    CreateAssessment() {
      this.template = this.selectedTemplate;
      this.assessment.test = this.template.test;
      this.assessment.rubric = this.template.rubric;
      if (this.assessment.test_responses == null) {
        this.assessment.test_responses = Array(
          this.assessment.test.length
        ).fill("");
      }
    },
    getNewTraits() {
      let traits = [];
      let header = null;
      for (var trait of this.assessment.rubric.traits) {
        if (trait.min == trait.max) {
          header = trait;
        }
        if (trait.keep == true) {
          if (header != null) {
            traits.push(header);
            header = null;
          }
          traits.push(trait);
        }
      }
      return traits;
    },
    getResources(from_approve = false) {
      let resources = this.assessment.item.resources;
      if (from_approve == true) {
        let body = "";
        for (let i = 0; i < this.assessment.test.length; i++) {
          body =
            body +
            '<div class="card-body" style="background-color:#DCDCDC;border:solid 1px #505050;padding:20px>"' +
            this.assessment.test[i] +
            "<p> </p>" +
            "</div>" +
            '<div class="card-body" style="border:solid 1px #505050;padding:20px>"' +
            this.assessment.test_responses[i] +
            "<p> </p>" +
            "</div>" +
            "<hr>";
        }
        let resource = {
          name: "Assessment Design",
          type: 4,
          body: body,
          sequence: 1,
          path: "/#/htmlview/" + this.assessment.id + "/1",
          mime_type: "text/html"
        };
        resources.push(resource);
      }
      return resources;
    },
    getStudentResources(from_approve = false) {
      if (from_approve == true) {
        let body = "";
        for (let i = 0; i < this.assessment.test.length; i++) {
          if (this.assessment.student_notes[i] == true) {
            body =
              body +
              '<div class="card-body" style="background-color:#DCDCDC;border:solid 1px #505050;padding:20px>"' +
              this.assessment.test[i] +
              "<p> </p>" +
              "</div>" +
              '<div class="card-body" style="border:solid 1px #505050;padding:20px>"' +
              this.assessment.test_responses[i] +
              "<p> </p>" +
              "</div>" +
              "<hr>";
          }
        }
        let resource = {
          name: "Assessment Student Notes",
          type: 4,
          body: body,
          sequence: 2,
          path: "/#/htmlview/" + this.assessment.id + "/2",
          mime_type: "text/html"
        };
        console.log(resource);
        return resource;
      }
      return false;
    },
    initValidation() {
      this.valid = ValidationService.newValidator({
        name: {
          group: "details",
          errorMsg: "You must assign a name",
          func: () => {
            return (
              this.assessment &&
              this.assessment.name &&
              this.assessment.name != ""
            );
          }
        },
        ref: {
          group: "details",
          errorMsg: "You must assign a reference ID",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              this.assessment.ref_id != ""
            );
          }
        },
        ref_unique: {
          group: "details",
          errorMsg:
            "This Reference ID is already assigned to another Assessment",
          func: () => {
            return this.assessment && this.isUnique;
          }
        },
        ref_char: {
          group: "details",
          errorMsg:
            "Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              fs.isGoodRefID(this.assessment.ref_id)
            );
          }
        }
      });
    },
    removeItem(item) {
      this.assessment.assessment_items.pop(item);
    },
    resourceErr() {
      Notie.warning("Please save the assessment before uploading resources");
    },
    blankAssessment() {
      return {
        loaded: 0,
        standards: []
      };
    },

    watchChanges() {
      if (this.unwatch) {
        this.unwatch();
      }
      this.unwatch = this.$watch(
        "assessment",
        (newc, old) => {
          console.log("new assessment ", this.assessment.item.name);
          console.log("new assessment ", this.assessment.item.active);
          console.log("new assessment ", this.assessment.item.standards);

          this.dirty = true;
        },
        { deep: true }
      );
    },
    blankItem() {
      return {
        validity_config: {},
        qualification_config: {},
        calibration_config: {},
        learnosity_config: {},
        crase_config: {},
        erater_config: {},
        api_export_config: {},
        exception_config: {},
        reliability_percent: 100,
        use_considerations: true,
        use_comments: true,
        resources: []
      };
    },
    loadData() {
      console.log("LOADING DATA");
      this.dirty = false;
      var loaded = this.assessment.loaded;
      loaded++;
      if (this.params.id != "new") {
        return BB.props({
          assessment: AssessmentService.getTempAssessment(this.params.id),
          contentAreas: ContentAreaService.listContentAreas(),
          grades: GradeService.listGrades(),
          districts: DistrictService.listDistricts({}),

          isScored: AssessmentService.isScored(this.params.id),
          refidsres: AssessmentService.getRefIDs()
        })
          .then(resps => {
            this.LoadTemplate(resps.assessment.data.template_id);

            this.assessment = resps.assessment.data;
            this.assessment.loaded = loaded;
            this.assessment.item.isScored = resps.isScored.data;
            // this.assessment.standards = this.assessment.item.standards;
            this.originalResources = _.cloneDeep(
              this.assessment.item.resources
            );
            this.RefIDs = resps.refidsres.data.RefIDs.filter(
              x => x !== this.assessment.ref_id
            );
            // console.log(new Set(this.RefIDs).size)

            if (!this.assessment.rubric_id) {
              this.assessment.rubric = this.assessment.item.rubric;
              this.assessment.rubric_id = this.assessment.item.rubric_id;
              this.assessment.type = this.assessment.item.type;
            }
            if (!this.assessment.essential_skills) {
              this.assessment.essential_skills = [];
            }
            if (!this.assessment.assessment_purpose) {
              this.assessment.assessment_purpose = [];
            }
            console.log(resps.isScored);
            this.originalDesc = this.assessment.description;
            this.refresh = new Date();

            this.contentAreas = resps.contentAreas.data.content_areas;
            this.selectedContentArea = _.find(this.contentAreas, {
              id: this.assessment.content_area_id
            });
            this.updateContentAreaID(this.selectedContentArea);

            this.sGrades = [];
            this.grades = resps.grades.data;
            if (this.grades && this.grades.length > 0 && this.assessment) {
              _.each(this.assessment.grade_ids, gid => {
                let grade = _.find(this.grades, {
                  id: gid
                });
                if (grade) {
                  this.sGrades.push(grade);
                }
              });
            }

            this.districts = resps.districts.data.districts;
            this.sDistrict = _.find(this.districts, {
              id: this.assessment.district_id
            });
            console.log("Districts ", resps.districts.data);

            this.loading = false;

            this.checkAutoRef();
            this.watchChanges();
          })
          .catch(err => {
            console.log(err);
            // Notie.error("Assessment not found, adding new assessment instead");
            this.$router.go(-1);
          });
      } else {
        ContentAreaService.listContentAreas()
          .then(resp => {
            this.contentAreas = resp.data.content_areas;
            this.selectedContentArea = this.contentAreas[0];

            this.assessment = this.blankAssessment();
            this.assessment.loaded = loaded;
            this.$set(this.assessment, "name", "New Assessment");
            this.$set(this.assessment, "ref_id", "new_assessment");
            this.assessment.item = this.blankItem();
            this.$set(this.assessment.item, "name", "New Item");
            this.$set(this.assessment.item, "ref_id", "new_item");
            this.assessment.assessment_items = [];
            this.assessment.essential_skills = [];

            this.assessment.assessment_purpose = [];

            this.updateContentAreaID(this.selectedContentArea);
            this.watchChanges();
          })
          .catch(err => {
            Notie.error("Failed to load content areas");
          });
        GradeService.listGrades()
          .then(resp => {
            this.grades = resp.data;
          })
          .catch(err => {
            Notie.error("Failed to load grades");
          });
        AssessmentService.getRefIDs()
          .then(resp => {
            this.RefIDs = resp.data.RefIDs;
          })
          .catch(err => {
            Notie.error("Failed to load RefIDs");
          });
        DistrictService.listDistricts({})
          .then(resp => {
            this.districts = resp.data.districts;
            this.sDistrict = this.districts.filter(obj => {
              return obj.id === this.user.district_id;
            })[0];
          })
          .catch(err => {
            Notie.error("Failed to load Districts");
          });
      }
    },

    updateContentAreaID(contentArea) {
      this.assessment.content_area_id = (contentArea && contentArea.id) || "";
    },
    updateDistrictID(district) {
      this.assessment.district_id = (contentArea && contentArea.id) || "";
    },
    LoadToItems(from_approve = false) {
      console.log(this.assessment);
      // this.assessment.rubric_id = this.assessment.rubric.id;
      // this.assessment.item.rubric_id = this.assessment.rubric.id;
      this.assessment.item.rubric = this.assessment.rubric;
      this.assessment.item.type = this.assessment.type;
      this.assessment.item.standards = this.assessment.standards;
      this.assessment.item.essential_skills = this.assessment.essential_skills;
      this.assessment.item.assessment_purpose = this.assessment.assessment_purpose;

      // this.assessment.rubric.traits = this.getNewTraits()
      this.assessment.item.resources = this.getResources(from_approve);
    },
    LoadTemplates() {
      return TemplateService.listTemplates()
        .then(resp => {
          console.log("Got templates", resp.data);
          this.templates = resp.data.templates;
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to Get Templates", err);
        });
    },
    LoadTemplate(id) {
      return TemplateService.getTemplate(id)
        .then(resp => {
          console.log("Got templates", resp.data);
          this.template = resp.data;
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to Get Templates", err);
        });
    },

    saveAssessment(from_feedback = false) {
      // debugger;

      // this.template.rubric.traits = this.getNewTraits()
      return RubricService.saveTempRubric(this.assessment.rubric)
        .then(resp => {
          console.log("Rubric Saved", resp.data.id);
          //saving assessment after saving rubric
          this.LoadToItems();
          this.assessment.rubric_id = resp.data.id;
          this.assessment.item.rubric_id = resp.data.id;
          this.assessment.template_id = this.template.id;
          if (from_feedback) {
            this.assessment.status = "Action Required";
          }
          if (!this.assessment.feedback) {
            this.assessment.feedback = [];
          }
          if (this.feedback.message != "") {
            this.feedback.date = new Date().toLocaleString().replace(",", "");
            this.feedback.username = this.user.full_name;
            this.assessment.feedback.push(this.feedback);
          }
          this.feedback = { message: "", type: 1 };
          return AssessmentService.saveTempAssessment(this.assessment)
            .then(resp => {
              console.log(
                "ITEM ",
                this.assessment.item.reliability_percent,
                this.assessment.item.individual_limit_percent
              );
              if (!from_feedback) {
                Notie.info("Assessment Saved");
              }
              if (from_feedback) {
                Notie.info("Feedback sent");
              }
              this.loadData();
            })
            .catch(err => {
              console.log(err);
              Notie.error("Failed to save assessment", err);
            });
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to save rubric", err);
        });
    },
    ApproveAssessment() {
      // debugger;
      this.approving = true;
      this.assessment.rubric.traits = this.getNewTraits();
      this.rubricOldID = this.assessment.rubric.id;
      this.assessment.rubric.id = null;
      this.assessment.rubric.ref_id = this.assessment.id;
      this.assessment.rubric.master_rubric = false;
      this.assessment.user = null;
      this.assessment.rubric.from_assessment = true;
      this.assessment.rubric.name =
        this.assessment.rubric.name + " - " + this.assessment.name;
      return RubricService.saveRubric(this.assessment.rubric)
        .then(resp => {
          console.log("Rubric Saved", resp.data.id);
          //saving assessment after saving rubric
          this.LoadToItems(true);
          this.assessment.rubric_id = resp.data.id;
          this.assessment.item.rubric_id = resp.data.id;
          this.assessment.template_id = this.template.id;
          this.assessment.item.resources.push(this.getStudentResources(true));
          return AssessmentService.saveAssessment(this.assessment)
            .then(resp => {
              Notie.info("Assessment Approved");
              this.dirty = false;

              this.ClearTemp();
            })
            .catch(err => {
              console.log(err);
              Notie.error("Failed to save assessment", err);
            });
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to save rubric", err);
        });
    },

    ClearTemp() {
      return RubricService.removeTempRubric(this.rubricOldID)
        .then(resp => {
          console.log("Rubric Deleted");

          return AssessmentService.removeTempAssessment(this.assessment.id)
            .then(resp => {
              Notie.info("Assessment Approved");
              this.$forceUpdate();
              console.log("router changed", this.$router);
              this.$router.go(-1);
            })
            .catch(err => {
              console.log(err);
              Notie.error("Failed to Remove Temp assessment", err);
            });
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to Remove Temp rubric", err);
        });
    },

    checkAutoRef() {
      let genRef = this.generateAutoRef(this.assessment.name);
      this.autoRef = this.assessment.ref_id == genRef;
    },
    generateAutoRef(name) {
      return name && fs.toGoodRefID(name);
    },
    canSave() {
      return this.dirty;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/AssessmentApprove.vue